import React, {useContext} from "react";
import {TableContext} from "../index";
import {Checkbox} from "../view/Checkbox";
import {deepCopy} from "../utils";
import dots from "../_resources/img/vdots.png";

const Severity = {
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low'
}

function ViolationsTableRow({data, index}) {

  const {config, setConfig} = useContext(TableContext);

  const getCircleType = () => {

    if (!data.severity) {
      return '';
    }

    switch (data.severity.toLowerCase()) {
      case Severity.HIGH:
        return "danger";
      case Severity.MEDIUM:
        return "warning";
      case Severity.LOW:
        return "success";
      default:
        return "success";
    }
  }

  const getValidColor = () => {
    switch (data.valid) {
      case 1:
        return "success";
      case 0:
        return "danger";
      case -1:
        return "warning";
      default:
        return "success";
    }
  }

  const onCheckboxChange = () => {
    let selectedRows = deepCopy(config.selected);
    if (selectedRows.includes(data.id)) {
      selectedRows.splice(selectedRows.indexOf(data.id), 1);
    } else {
      selectedRows.push(data.id)
    }
    setConfig({...config, selected: selectedRows})
  }

  return (
      <tr key={index}>
        <td>
          <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()}/>
        </td>
        <td>{data.rule}</td>
        <td>{data.details}</td>
        <td>
          {data.expectedOutput}
        </td>
        <td>
          {data.user}
        </td>
        <td>
          <span className={`font-weight-bold oct_text-${getCircleType()}`}>{data.severity?.toUpperCase()}</span>
        </td>
        <td>
                <span
                    className={`font-weight-bold oct_text-${getValidColor()}`}>
                {data.valid === 1 ? 'PASS' : data.valid === -1 ? 'UNKNOWN' : 'FAIL'}
                </span>
        </td>
        <td>
          {data.device}
        </td>
        <td>
          {data.group}
        </td>
        <td>
          <div className="btn oct_btn-tool-table">
            <i className="fas fa-ellipsis-v"></i>
            <img src={dots} alt="Icon" className="oct_vertical_align" />
          </div>
        </td>
      </tr>
  )

}

export default ViolationsTableRow;
